import React from "react";

const Share = () => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 15 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g style={{ mixBlendMode: "luminosity" }}>
        <path
          d="M7.50781 12.4141C7.90625 12.4141 8.23438 12.0859 8.23438 11.6953V3.83594L8.17969 2.67969L8.65625 3.25L9.75 4.41406C9.875 4.55469 10.0547 4.625 10.2344 4.625C10.5938 4.625 10.8906 4.36719 10.8906 4C10.8906 3.80469 10.8125 3.66406 10.6797 3.53125L8.0625 1.00781C7.875 0.820312 7.69531 0.757812 7.50781 0.757812C7.3125 0.757812 7.14062 0.820312 6.95312 1.00781L4.32812 3.53125C4.19531 3.66406 4.11719 3.80469 4.11719 4C4.11719 4.36719 4.40625 4.625 4.76562 4.625C4.94531 4.625 5.13281 4.55469 5.25781 4.41406L6.35156 3.25L6.83594 2.67188L6.77344 3.83594V11.6953C6.77344 12.0859 7.10156 12.4141 7.50781 12.4141ZM3 18.6562H12C13.6953 18.6562 14.5703 17.7812 14.5703 16.1094V8.42969C14.5703 6.75781 13.6953 5.88281 12 5.88281H9.89062V7.4375H11.8984C12.6094 7.4375 13.0156 7.8125 13.0156 8.5625V15.9688C13.0156 16.7188 12.6094 17.0938 11.8984 17.0938H3.10156C2.38281 17.0938 1.98438 16.7188 1.98438 15.9688V8.5625C1.98438 7.8125 2.38281 7.4375 3.10156 7.4375H5.13281V5.88281H3C1.3125 5.88281 0.429688 6.75 0.429688 8.42969V16.1094C0.429688 17.7812 1.3125 18.6562 3 18.6562Z"
          fill="#797979"
        />
      </g>
    </svg>
  );
};

export default Share;
